import React, { useMemo, useState, useRef, useEffect } from "react";
import { useNavigate, useParams,Link } from "react-router-dom";
import {
  Layout,
  Row,
  Col,
  Form,
  Select,
  Button,
  Breadcrumb,
  AutoComplete,
} from "antd";
import { Trans, useTranslation } from "react-i18next";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import PermissionPanelStep from "../../authentication/steps/PermissionPanelStep";
import InputField from "../../common/htmlComponents/InputField";
import { authUserData } from "../../utils/Helper";

const { Content } = Layout;

const AddUserRole = () => {
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const companyAdmin = authUserData()?.company_role ? authUserData()?.company_role : null;
  const vendorAdmin = authUserData()?.vendor_role ? authUserData()?.vendor_role : null;
  const vendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const formRef = useRef();

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { id } = useParams();
  const groupId = id ? atob(id) : null;

  const [permissions, setPermissions] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedAppLabel, setSelectedAppLabel] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  let initialState;

  initialState = {
    group_name: "",
    role_family: null,
    permissions: [],
  };

  const [state, setState] = useState(initialState);
  const [familyName, setFamilyName] = useState([]);
  const { Option } = AutoComplete;

  const fetchPermissions = async () => {
    try {
      const response = await getRequest(`create-group-permissions/${groupId}/`);

      if (response.data.success) {
        setState({
          group_name: response.data.response.group_name,
          role_family: response.data.response.role_family,
          permissions: response.data.response.permissions.map(
            (permission) => permission.id
          ),
        });
        formRef.current.setFieldsValue({
          ...state,
          group_name: response.data.response.group_name,
          role_family: response.data.response.family_name,
        });
      } else {
        console.error("Error fetching permissions:");
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    if (groupId) {
      fetchPermissions();
    }
  }, [groupId]);

  useEffect(() => {
    PRApprovalHierarchyGetById();
    getFamilyName();
  }, [selectedModel, selectedAppLabel]);
  const PRApprovalHierarchyGetById = async () => {
    setLoading(true);

    try {

      let apiResponse;

      if (CompanyId) {
        apiResponse = await getRequest(`list-permission/?group_name=${companyAdmin}`);
      } else {
        apiResponse = await getRequest(`list-permission/?group_name=${vendorAdmin}`);
      }

      if (apiResponse.status) {
        setPermissions(apiResponse.data.data);
      } else {
        ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getFamilyName = async (data) => {
    await getRequest("role-family/?no_pagination=True", data).then(
      (response) => {
        setFamilyName(response.data.data);
      }
    );
  };
  const handleFamilySelectChange = async (value) => {
    setState({ ...state, role_family: value });
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null });
  };

  const getUniqueObjectsByModelName = (permissions) => {
    const uniqueObjects = [];
    const modelNames = new Set();

    permissions.forEach((permission) => {
      if (!modelNames.has(permission.model)) {
        modelNames.add(permission.model);
        uniqueObjects.push(permission);
      }
    });

    return uniqueObjects;
  };
  const uniquePermissions = useMemo(
    () => getUniqueObjectsByModelName(permissions),
    [permissions]
  );

  const handleSubmit = async () => {
    setBtnLoading(true);

    let payload;
    if (CompanyId) {
      payload = {
        ...state,
        company: CompanyId,
      };
    } else if (vendorId) {
      payload = {
        ...state,
        vendor: vendorId,
      };
        delete payload.role_family;
    }
    try {
      let apiResponse;

      if (groupId === null) {
        apiResponse = await postRequest("create-group-permissions/", payload);
      } else {
        apiResponse = await patchRequest(
          `create-group-permissions/${groupId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          groupId === null
            ? t("Group added successfully")
            : t("Group updated successfully")
        );
        updateSubscriptionStatus();

        navigate("/user-role");
      } else {
        ErrorNotificationMsg(t("Error in group"));
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);
    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };


  return (
    <>
          <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
               {groupId ? (
                <h3>Edit User Group</h3>
              ) : (
                <h3>Add User Group</h3>
              )}
               
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
       {groupId ? (
                 <Breadcrumb.Item>Edit User Group</Breadcrumb.Item>
              ) : (
                <Breadcrumb.Item>Add User Group</Breadcrumb.Item>
              )}
                 
                 
                </Breadcrumb>
                </div>
         
              
            </div>
          </div>
   
       
        
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef} className="stepscontentwrap">
              <div className="stepsContent">
                <div className="formwrapper">
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                      <Form.Item>
                        <InputField
                          name="group_name"
                          label={t("Functional Designation")}
                          placeholder={t("Enter Functional Designation")}
                          rules={t("Enter valid designation")}
                          pattern={"^[a-zA-Z ()]+$"}
                          handleInputChange={handleInputChange}
                          max={50}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        {CompanyId && <Form.Item
                        name="role_family"
                        label=" Family Name"
                        rules={[
                          {
                            required: true,
                            message: <Trans>Please select family</Trans>,
                          },
                        ]}
                      >
                        <Select
                          showArrow
                          showSearch
                          optionFilterProp="children"
                          placeholder="Select Family"
                          onChange={(value) => handleFamilySelectChange(value)}
                        >
                          {familyName.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.family_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item> }
                    </Col>
                  </Row>
                  <div className="sectiontitle">Permissions</div>

                  <div style={{ paddingRight: "5px" }}>
                    {uniquePermissions.map((permission, index) => {
                      return (
                        <>
                          {groupId !== null && groupId !== undefined ? (
                            <PermissionPanelStep
                              appLabel={permission.content_type_id}
                              modelName={permission.model.toLowerCase()}
                              groupId={groupId}
                              state={state}
                              setState={setState}
                              index = {index}
                              CompanyId={CompanyId}
                              vendorId={vendorId}
                            />
                          ) : (
                            <PermissionPanelStep
                              appLabel={permission.content_type_id}
                              modelName={permission.model.toLowerCase()}
                              state={state}
                              setState={setState}
                              CompanyId={CompanyId}
                              vendorId={vendorId}
                            />
                          )}
                        </>
                      );
                    })}
                    
                  </div>
                </div>
              </div>
              <div className="stepsFooter">
                <Button
                  cursor="pointer"
                  type="secondary"
                  className="primary"
                  onClick={() => navigate("/user-role")}
                >
                  Previous
                </Button>
                <Button
                  cursor="pointer"
                  type="primary"
                  className="primary"
                  htmlType="Submit"
                  label={t("save")}
                  loading={btnLoading}
                >
                  Save
                </Button>
              </div>
            </Form>
        
   
    </>
  );
};

export default AddUserRole;
